var _path, _path2, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDecred(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 40C31.0457 40 40 31.0457 40 20C40 8.95431 31.0457 0 20 0C8.95431 0 0 8.95431 0 20C0 31.0457 8.95431 40 20 40Z",
    fill: "#662D91"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1_94",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 40,
    height: 40
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20 40C31.0457 40 40 31.0457 40 20C40 8.95431 31.0457 0 20 0C8.95431 0 0 8.95431 0 20C0 31.0457 8.95431 40 20 40Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1_94)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.6243 29.4343L20.9908 26.8104C21.0307 26.771 21.0041 26.7054 20.9376 26.7054H18.3318C18.3185 26.7054 18.2919 26.6923 18.2786 26.6792L16.0716 24.239C16.0583 24.2128 16.0451 24.1866 16.0583 24.1603L19.7543 17.9024C19.7676 17.8762 19.7676 17.85 19.7543 17.8368L18.2254 15.2392C18.1988 15.1999 18.1324 15.1999 18.1058 15.2392L12.6415 24.5014C12.6283 24.5277 12.6283 24.5539 12.6415 24.5801L17.0289 29.4474C17.0422 29.4605 17.0555 29.4736 17.0821 29.4736H18.5711C18.5844 29.4605 18.611 29.4474 18.6243 29.4343V29.4343Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.704 14.2159C18.6907 14.2422 18.6907 14.2684 18.704 14.2815L20.2994 16.9841L24.5272 24.1472C24.5405 24.1734 24.5405 24.1997 24.5139 24.2259L22.2804 26.6923L19.9006 29.3424C19.8607 29.3818 19.8873 29.4474 19.9537 29.4474H23.5168C23.5301 29.4474 23.5567 29.4342 23.57 29.4211L27.9573 24.5539C27.9706 24.5276 27.9839 24.5014 27.9706 24.4752L20.3526 11.6183C20.3393 11.5658 20.2728 11.5658 20.2462 11.6183L18.704 14.2159Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDecred);
export default __webpack_public_path__ + "static/media/decred.c07f72bd2c49a71e0fe85012bbc46fd0.svg";
export { ForwardRef as ReactComponent };